import * as React from 'react';
import Progress from "./Progress";

export const QuoteFormProgressBar = (props: { completed: number; show: boolean }) => {

    if (!props.show) return null;

    const divStyle = {
        marginBottom: "15px"
    };

    const textPercentageStyle = {
        fontSize: "12px",
        marginTop: "5px",
        textAlign: "center" as const
    }

    return <div className="quote-form-progress-bar" style={divStyle}>
        <Progress completed={props.completed} />
        <h2 style={textPercentageStyle}>
            Progress: {props.completed}%
        </h2>
    </div>
}